import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { createSelector } from 'reselect'
import getIsInsurnaceDomesticTrip from '../view/getIsInsurnaceDomesticTrip'
import { findPostPurchaseCheckout, isBedbankItem, isLEHotelItem } from 'lib/checkout/checkoutUtils'
import { isInsuranceBookingProtectionAvailableForCartItemTypes, isInsuranceBookingProtectionAvailableForRegions } from './isBookingProtectionAvailable'
import { isStandaloneFlights } from '../view/flights'
import isInsuranceBookingProtectionPostPurchaseEnabled from 'selectors/isInsuranceBookingProtectionPostPurchaseEnabled'
import getAllInsuranceBookingProtectionItems from '../view/getAllInsuranceBookingProtectionItems'
import { isSpoofed } from 'selectors/featuresSelectors'
import { getOccupantsFromCartItems } from './insurance'

export const cartHasHotelItem = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => items.length > 0 && items.some(item => isLEHotelItem(item) || isBedbankItem(item)),
)

const isBookingProtectionEnabled = createSelector(
  (state: App.State) => getOccupantsFromCartItems(state),
  (state: App.State) => getIsInsurnaceDomesticTrip(state),
  (state: App.State) => cartHasHotelItem(state),
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isInsuranceBookingProtectionAvailableForCartItemTypes(state),
  (state: App.State) => isInsuranceBookingProtectionAvailableForRegions(state),
  (state: App.State) => !!getOptimizelyExperimentVariation(state, OptimizelyExperiments.isCfmrEnabledForInternationalHotels),
  (state: App.State) => isStandaloneFlights(state),
  (state:App.State) => !!findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => isInsuranceBookingProtectionPostPurchaseEnabled(state),
  (state: App.State) => getAllInsuranceBookingProtectionItems(state),
  (state: App.State) => isSpoofed(state),
  (occupants,
    isDomesticTrip,
    cartHasHotelItem,
    currentRegionCode,
    isAvailableForItemTypes,
    insuranceBookingProtectionEnabled,
    isCfmrEnabledForInternationalHotels,
    isStandaloneFlightsCheckout,
    isPostPurchase,
    isPostPurchaseEnabled,
    insuranceBookingProtectionItems,
    isSpoofed,
  ): boolean => {
    if (!occupants) return false

    if (!insuranceBookingProtectionEnabled) return false

    if (isPostPurchase) {
      return isPostPurchaseEnabled
    }

    if (!isSpoofed && currentRegionCode === 'AU' && !isDomesticTrip && cartHasHotelItem && !isCfmrEnabledForInternationalHotels) {
      return false
    }

    if (!isAvailableForItemTypes) return false

    const containsEmbeddedFlightProtection = insuranceBookingProtectionItems.some(item => item.flightJourneysKeys?.length)
    if (isStandaloneFlightsCheckout && !containsEmbeddedFlightProtection) return false

    return true
  },
)

export default isBookingProtectionEnabled
